import { createContext, useContext } from "react";

/**
 * True when the mobile drawer is drilled into an inspector drill-in panel
 * (`Base`, `Terrain`, …) so nested {@link InspectorRow} can match drawer nav
 * row metrics without threading props through each card.
 */
export const DrawerInspectorDrillLayoutContext = createContext(false);

export function useDrawerInspectorDrillLayout(): boolean {
  return useContext(DrawerInspectorDrillLayoutContext);
}
